import { z } from 'zod';
import { EnumSchema, FromSchema } from '../../../../common/src';

export enum SyncPeriodUnit {
    every15Minutes = 'every15Minutes',
    everyXHours = 'everyXHours',
    onceADay = 'onceADay',
    twiceADay = 'twiceADay',
}

export const PeriodicErpSyncSchema = z
    .object({
        isManual: z.boolean().optional(),
        unit: EnumSchema(SyncPeriodUnit).optional().nullable(),
        values: z.array(z.number()).optional().nullable(),
        timezone: z.string().optional().nullable(),
    })
    .refine(
        (data) => {
            if (
                (data.unit === SyncPeriodUnit.everyXHours ||
                    data.unit === SyncPeriodUnit.everyXHours ||
                    data.unit === SyncPeriodUnit.onceADay) &&
                !data.values
            ) {
                return false;
            }
            if (data.unit === SyncPeriodUnit.twiceADay && data.values?.length !== 2) {
                return false;
            }
            return true;
        },
        {
            message: 'Invalid sync period',
            path: ['unit'],
        },
    )
    .refine(
        (data) => {
            if (data.unit === SyncPeriodUnit.twiceADay && data.values && data.values[0] === data.values[1]) {
                return false;
            }
            return true;
        },
        {
            message: 'Duplicate sync time selected',
            path: ['values'],
        },
    );

export class PeriodicErpSync extends FromSchema(PeriodicErpSyncSchema) {
    isManual: boolean;
    unit?: SyncPeriodUnit | null;
    values?: number[] | null;
    timezone?: string | null;
}
